const serialize = (input) => {
    if (input instanceof FormData) return input;
    if (input instanceof HTMLFormElement) return new FormData(input);

    const fData = new FormData();

    if (typeof input?.length === 'number' && input[0]?.form instanceof HTMLFormElement) {
        return new FormData(input[0].form);
    }

    if (input && typeof input === 'object') {
        for (const [key, value] of Object.entries(input)) {
            if (value !== undefined && value !== null) fData.append(key, value);
        }
    }

    return fData;
};

export default serialize;
